<pv-toolbar [showLeftActions]="false" [title]="'medication.found_medication_incidents.steps.title' | translate">
	<ng-container class="right-actions">
		<button data-test="close-button" (click)="onExit()">
			<i class="fa fa-times"></i>
		</button>
	</ng-container>
</pv-toolbar>

<steps [activeStep]="activeStep" [pages]="3">
	<step
		[canGoNext]="selectedDate && locationForm.valid"
		[page]="1"
		[showBackButton]="false"
		[stepId]="Step.DATE_LOCATION"
		(goNext)="gotoStep(Step.LIST)"
		(nextClick)="markDateLocationAsTouched()"
	>
		<ic-single-select-list
			[label]="'medication.found_medication_incidents.steps.date_location.date' | translate"
			[options]="dateOptions"
			[showErrors]="dateTouched"
			[(selection)]="selectedDate"
		/>

		<ic-found-medication-incident-location
			[form]="locationForm"
			[label]="'medication.found_medication_incidents.steps.date_location.location' | translate"
		/>
	</step>

	<step
		[canGoNext]="details.length > 0"
		[page]="2"
		[stepId]="Step.LIST"
		(goBack)="gotoStep(Step.DATE_LOCATION)"
		(goNext)="gotoStep(Step.SUMMARY)"
		(nextClick)="detailsStepTouched = true"
	>
		<div class="add-medication-buttons">
			<ic-icon-button data-test="add-known-medication-button" icon="fa-plus" (click)="showAddMedicationPopup()">{{
				"medication.add_medication.add_known" | translate
			}}</ic-icon-button>
			<ic-icon-button
				data-test="add-unknown-medication-button"
				icon="fa-plus"
				(click)="showAddUnknownMedicationPopup()"
				>{{ "medication.add_medication.add_unknown" | translate }}</ic-icon-button
			>
		</div>

		<h2>{{ "medication.add_medication.title" | translate }}</h2>
		<ic-found-medication-incident-details-list
			[details]="details"
			[touched]="detailsStepTouched"
			(deleteDetail)="deleteDetail($event)"
		/>
	</step>

	<step
		nextButtonIcon="fa fa-save"
		[canGoNext]="summaryForm.valid"
		[nextButtonDisabled]="isSaving()"
		[page]="3"
		[stepId]="Step.SUMMARY"
		(goBack)="gotoStep(Step.LIST)"
		(goNext)="saveIncident()"
		(nextClick)="summaryForm.markAllAsTouched()"
	>
		<ic-found-medication-incident-summary [medicationIncident]="getCreateFoundMedicationIncidentDTO()" />
		<ic-briefing-dar-remarks [form]="summaryForm" />
	</step>
</steps>
